import { render } from "./TextLabelNewArrivalCount.vue?vue&type=template&id=cf48569a&scoped=true&ts=true"
import script from "./TextLabelNewArrivalCount.vue?vue&type=script&lang=ts"
export * from "./TextLabelNewArrivalCount.vue?vue&type=script&lang=ts"

import "./TextLabelNewArrivalCount.vue?vue&type=style&index=0&id=cf48569a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf48569a"]])

export default __exports__